@if(titleConfig.showTitle) {
<div class="w-full">
  <div class="w-11/12 mx-auto pt-4 pb-2 md:pt-5 md:pb-3 animate-fade-in">
    <h1
      class="flex items-start gap-3 text-[1.65rem] md:text-3xl lg:text-[2.15rem] font-semibold tracking-tight text-gray-900 leading-snug">
      <span class="hidden md:inline-block h-6 w-1.5 rounded-sm bg-cyan-600 mt-1"></span>
      <span class="break-words">{{ titleConfig.title }}</span>
    </h1>
    @if(titleConfig.subtitle) {
    <p class="mt-1 text-sm md:text-base text-gray-600 max-w-4xl leading-relaxed break-words">
      {{ titleConfig.subtitle }}
    </p>
    }
    <div class="mt-3 md:mt-4 h-px w-full bg-gradient-to-r from-gray-200 via-gray-200/70 to-transparent"></div>
  </div>
</div>
}